<template>
    <div class="card h-auto card-basic card--blue ">
        <div class="card__image position-relative" :style="profileImage">
            <span v-if="member.imageUrl == null" class="card__initials">{{
                member.initials
            }}</span>
        </div>
        <div class="card__text">
            <div class="card__text__top mx-auto">
                <h2>{{ member.name }}</h2>
                <ul class="mb-2 list-unstyled card__list font-italic">
                    <li>
                        {{ member.company }}
                    </li>
                    <li>
                        {{ member.position }}
                    </li>
                    <li>
                        <a :href="'mailto:' + member.email">{{
                            member.email
                        }}</a>
                    </li>
                    <li>
                        {{ member.phone }}
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        member: {
            type: Object,
            default() {
                return {};
            }
        }
    },

    computed: {
        profileImage() {
            return [
                this.member.imageUrl == null
                    ? {
                          'background-color': '#F5F4F5'
                      }
                    : {
                          'background-image':
                              'url(' + this.member.imageUrl + ')'
                      }
            ];
        }
    }
};
</script>

<style lang="scss" scoped>
@import '@/scss/helpers/_extensions.scss';

a .card:hover {
    transform: none;
    @extend %box-shadow;
}

.card {
    display: flex;
    flex-direction: column;
}

.card__image {
    height: 160px;
    width: 160px;
    margin: 20px auto 0 auto;
    background-size: cover;
    background-position: center center;
    border-radius: 90px;
}

.card__text {
    padding: 0 10px 0 10px;
    min-height: 200px;
}

.card__text__top {
    max-width: 75%;
}

.card__text__top h2 {
    font-family: $menu-font-family;
}
</style>
